var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserProfile'),(_vm.$keycloak.realmAccess.roles.includes('granja-admin'))?_c('AdminFeatures'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }